import { z } from "zod";

// Base Comment Schema
export const baseCommentSchema = z.object({
  comment: z.string().min(1, "Comment cannot be empty"),
  projectId: z.string().uuid("Invalid project ID format"),
});

// Create Comment Schema
export const createCommentSchema = baseCommentSchema.extend({});

export type CreateCommentSchema = z.infer<typeof createCommentSchema>;

// Comment Schema (for responses)
export const commentSchema = baseCommentSchema.extend({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  createdAt: z.date(),
  user: z.object({
    name: z.string().nullable(),
    image: z.string().nullable(),
  }),
});

export type CommentSchema = z.infer<typeof commentSchema>;

// Update Comment Schema
export const updateCommentSchema = z.object({
  comment: z.string().min(1, "Comment cannot be empty"),
});

export type UpdateCommentSchema = z.infer<typeof updateCommentSchema>;
